import { Injectable } from '@angular/core'
import { Store, Action } from '@ngrx/store'

import * as EventTicketPackagesSelectors from './event-ticket-packages.selectors'
import { BehaviorSubject } from 'rxjs'
import { EventTicketPackagesState } from './event-ticket-packages.reducer'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPackagesFacade implements GbBaseFacade {
  eventTicketPackages$ = this.store.select(EventTicketPackagesSelectors.selectAllListLoadedEventTicketPackages)
  count$ = this.store.select(EventTicketPackagesSelectors.selectEventTicketPackageCount)
  order$ = this.store.select(EventTicketPackagesSelectors.selectEventTicketPackageOrder)
  stalePages$ = this.store.select(EventTicketPackagesSelectors.selectStalePages)
  selectedEventTicketPackage$ = this.store.select(EventTicketPackagesSelectors.selectedEventTicketPackage)
  selectedEventTicketPackageId$ = this.store.select(EventTicketPackagesSelectors.selectedEventTicketPackageId)
  selectedEventTicketPackageName$ = this.store.select(EventTicketPackagesSelectors.selectedEventTicketPackageName)
  selectedEventTicketPackageImages$ = this.store.select(EventTicketPackagesSelectors.selectedEventTicketPackageImages)

  changeEventTicketPackageBehaviorSubject$ = new BehaviorSubject(true)

  constructor(private store: Store<EventTicketPackagesState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }

  onEventTicketPackageChange(): void {
    this.changeEventTicketPackageBehaviorSubject$.next(false)
    setTimeout(() => this.changeEventTicketPackageBehaviorSubject$.next(true))
  }
}
